import { React, useState, useMemo } from "react"
import style from "./portfolio.module.scss"
// import s from "./workcard.module.scss"
import github from "../../icons/github.svg"
import avito from "../../images/avito.png"
import webdesign from "../../images/webdesign.png"
import portfolio from "../../images/portfolio.png"
import { useNavigate } from "react-router-dom"
import PortfolioCards from "./PortfolioCards/PortfolioCards"
const Portfolio = () => {
  const navigate = useNavigate()
  const goPortfolio = () => navigate("/portfolio")
  const goIntro = () => navigate("/")
  const [touchStart, setTouchStart] = useState(null)
  const [touchEnd, setTouchEnd] = useState(null)
  const minSwipeDistance = 150
  const onTouchStart = (e) => {
    setTouchEnd(null)
    setTouchStart(e.targetTouches[0].clientX)
  }
  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX)
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return
    const distance = touchStart - touchEnd
    const isRightSwipe = distance < -minSwipeDistance
    isRightSwipe ? goIntro() : console.log('sad');
  }
  return (
    <div
      className={style.wrappers}
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <PortfolioCards
        id='1'
        title='Avito analog for Argentina'
        img={avito}
        description='This is my graduation project, made in a team with a backend developer, an iOS developer and a web designer. Due to the strange wishes of the customer, we are prohibited from posting the source code on GitHub, so to get the source code, you can contact me via telegram or VK'
        stack=' ReactJs, Mobx, React Props, React Router Dom, SCSS, CSS Modules, Axios'
        problemsAndSolves=' Some problems and my solves of this problems'
        siteLink='https://t.me/rgm88'
        github='https://t.me/rgm88'
      />
      <PortfolioCards
        id='2'
        title='Web-designer blog'
        img={webdesign}
        description='A simple website made by myself as a part of the ReactJs study. Made according to a mockup that was found on the Internet'
        stack='  ReactJs, React Props, React Router Dom, SCSS, CSS Modules'
        problemsAndSolves=' Some problems and my solves of this problems'
        siteLink='https://maltcevrg.github.io/pet-project/'
        github='https://github.com/maltcevrg/pet-project '
      />
      <PortfolioCards
        id='3'
        title='Portfolio web-site'
        img={portfolio}
        description='My portfolio web-site, here you are right now'
        stack='  ReactJs, React Props, React Router Dom, SCSS, CSS Modules'
        problemsAndSolves=' Some problems and my solves of this problems'
        siteLink='https://github.com/maltcevrg/portfolio-web-site'
        github='https://github.com/maltcevrg/portfolio-web-site'
      />
    </div>
  )
}
export default Portfolio
